import { Controller } from "@hotwired/stimulus"

// Controller para gerenciar cliques nos cards de veículos
// Funcionalidade: busca rápida no mapa clicando no card
export default class extends Controller {
  static targets = ['card']

  connect() {
    // Usar event delegation para melhor performance
    this.boundHandleCardClick = this.handleCardClick.bind(this)
    this.element.addEventListener('click', this.boundHandleCardClick)
  }

  disconnect() {
    if (this.boundHandleCardClick) {
      this.element.removeEventListener('click', this.boundHandleCardClick)
      this.boundHandleCardClick = null
    }
  }

  handleCardClick(event) {
    const vehicleCard = event.target.closest('.vehicle-card')
    
    if (!vehicleCard) {
      return
    }

    const vehicleId = parseInt(vehicleCard.dataset.vehicleId)

    if (!vehicleId) {
      return
    }
    
    event.preventDefault()
    event.stopPropagation()
    
    this.showElegantFeedback(vehicleCard)
    
    const mapController = this.findMapController()
    
    if (mapController) {
      mapController.centerMapOnVehicle(vehicleId)
    }
  }

  findMapController() {
    const mapElement = document.querySelector('[data-controller*="monitoring-map"]')
    
    if (mapElement) {
      const controller = this.application.getControllerForElementAndIdentifier(mapElement, 'monitoring-map')
      return controller
    }
    
    return null
  }

  showElegantFeedback(card) {
    // Remover classe anterior se existir
    card.classList.remove('vehicle-card-neon-highlight')
    
    // Force reflow para garantir que a classe foi removida
    card.offsetHeight
    
    // Adicionar classe para borda neon azul elegante
    card.classList.add('vehicle-card-neon-highlight')
    
    // Remover highlight após animação
    setTimeout(() => {
      card.classList.remove('vehicle-card-neon-highlight')
    }, 1500)
  }
}